import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { ApplicationPackage } from './application-package.service';

@Injectable({
  providedIn: 'root'
})
export class PermitApplicationService {

  private applicationSource = new BehaviorSubject<PermitApplicationFormData>(null);
  currentApplication = this.applicationSource.asObservable();

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getApplication(applicationId: number) {
    this.http.get<PermitApplicationApiData>(`${this.baseUrl}api/permitapplication/${applicationId}`).subscribe(
      response => {
        if (response) {
          this.changeApplication(this.generatePermitApplicationFormData(response));
        } else {
          this.changeApplication(null);
        }
      },
      error => console.error(error)
    );
  }

  putApplication(formData: PermitApplicationFormData, applicationPackage: ApplicationPackage) {
    let apiData = this.generatePermitApplicationApiData(formData, applicationPackage);
    // apiData.permitApplicationId = formData.permitApplicationId;
    this.http.put<PermitApplicationApiData>(`${this.baseUrl}api/permitapplication`, apiData).subscribe(
      response => {
        if (response) {
          this.changeApplication(this.generatePermitApplicationFormData(response));
        } else {
          this.changeApplication(null);
        }
      },
      error => console.error(error)
    );
  }

  postApplication(formData: PermitApplicationFormData, applicationPackage: ApplicationPackage) {
    let apiData = this.generatePermitApplicationApiData(formData, applicationPackage);
    this.http.post<PermitApplicationApiData>(`${this.baseUrl}api/permitapplication`, apiData).subscribe(
      response => {
        if (response) {
          this.changeApplication(this.generatePermitApplicationFormData(response));
        } else {
          this.changeApplication(null);
        }
      },
      error => console.error(error)
    );
  }

  generatePermitApplicationApiData(data: PermitApplicationFormData, applicationPackage: ApplicationPackage) {
    const newApplicationData: PermitApplicationApiData = {
      // Added initially
      applicationPackageId: applicationPackage.applicationPackageId,
      projectTypeId: data.projectTypeId,
      projectTypeName: data.projectTypeName,
      sourceName: data.sourceName,
      diversionTypeId: data.diversionTypeId,
      diversionStructureName: data.diversionStructureName,
      diversionCFSMax: data.diversionCFSMax,
      maximumCFSRequested: data.maximumCFSRequested,
      minimumCFSNeeded: data.minimumCFSNeeded,
      ifNotCompletedWhenWillItBeDate: data.ifNotCompletedWhenWillItBeDate,
      earliestDateForDiversion: data.earliestDateForDiversion,
      federalAssistance: data.federalAssistance,
      isThereSecondaryPurpose: data.isThereSecondaryPurpose,
      ifSecondaryPurposeHowMany: data.ifSecondaryPurposeHowMany,
      canEdit: data.canEdit,
      waterRightsId: data.waterRightsId,
      applicationNumber: data.applicationNumber
    }
    return newApplicationData;
  }

  generatePermitApplicationFormData(data: PermitApplicationApiData) {
    const newApplicationData: PermitApplicationFormData = {
      // Added initially
      applicationPackageId: data.applicationPackageId,
      projectTypeId: data.projectTypeId,
      projectTypeName: data.projectTypeName,
      sourceName: data.sourceName,
      diversionTypeId: data.diversionTypeId,
      diversionStructureName: data.diversionStructureName,
      diversionCFSMax: data.diversionCFSMax,
      maximumCFSRequested: data.maximumCFSRequested,
      minimumCFSNeeded: data.minimumCFSNeeded,
      ifNotCompletedWhenWillItBeDate: data.ifNotCompletedWhenWillItBeDate,
      earliestDateForDiversion: data.earliestDateForDiversion,
      federalAssistance: data.federalAssistance,
      isThereSecondaryPurpose: data.isThereSecondaryPurpose,
      ifSecondaryPurposeHowMany: data.ifSecondaryPurposeHowMany,
      canEdit: data.canEdit,
      waterRightsId: data.waterRightsId,
      applicationNumber: data.applicationNumber
    }
    return newApplicationData;
  }
  changeApplication(application) {
    this.applicationSource.next(application);
  }

}

export interface PermitApplicationApiData {
  // Added initially
  applicationPackageId: number,
  projectTypeId: number,
  projectTypeName: string,
  sourceName?: string, // ppod_sourceName
  diversionTypeId?: number, // ppod_diversionType
  diversionStructureName?: string, // ppod_canalName
  diversionCFSMax?: number, // ppod_
  maximumCFSRequested?: number,
  minimumCFSNeeded?: number,
  ifNotCompletedWhenWillItBeDate?: Date,
  earliestDateForDiversion: Date,
  federalAssistance?: boolean
  isThereSecondaryPurpose?: boolean
  ifSecondaryPurposeHowMany?: number,
  canEdit?: boolean,
  waterRightsId: string,
  applicationNumber: string
}

// Priority Date and Approval Date are type 'Date' in C#

export interface PermitApplicationFormData {
  // Added initially
  applicationPackageId: number,
  projectTypeId: number,
  projectTypeName: string,
  sourceName?: string, // ppod_sourceName
  diversionTypeId?: number, // ppod_diversionType
  diversionTypeName?: string, // ppod_diversionTypeName
  diversionStructureName?: string, // ppod_canalName
  diversionCFSMax?: number, // ppod_
  maximumCFSRequested?: number,
  minimumCFSNeeded?: number,
  ifNotCompletedWhenWillItBeDate?: Date,
  earliestDateForDiversion: Date,
  federalAssistance?: boolean,
  isThereSecondaryPurpose?: boolean,
  ifSecondaryPurposeHowMany?: number,
  canEdit?: boolean,
  waterRightsId: string,
  applicationNumber: string
}
